import React from 'react'

import { DoctorFavorites } from 'presentation/doctor/pages/Favorites'

export default function makeDoctorFavoritesFactory() {
  return <DoctorFavorites />
}
